import { useAemConfig } from '@as-react/common-components';
import { parseCategoryIds } from '@as-react/common-utils';
import { useMemo } from 'react';
export const useCategoryHierarchyTree = (categoryHierarchyTree, defaultFilter) => {
    const { lang } = useAemConfig();
    const walkAndMapCategoryHierarchyTree = (node) => {
        var _a, _b, _c, _d;
        if (!((_c = (_b = (_a = node === null || node === void 0 ? void 0 : node.category) === null || _a === void 0 ? void 0 : _a.categoryTranslatedProperties) === null || _b === void 0 ? void 0 : _b[lang.toLocaleUpperCase()]) === null || _c === void 0 ? void 0 : _c.link)) {
            return null;
        }
        return {
            item: Object.assign({ categoryPath: node.categoryPath }, node.category),
            children: (_d = node.children) === null || _d === void 0 ? void 0 : _d.map(nodeChild => walkAndMapCategoryHierarchyTree(nodeChild)).filter(nodeChild => !!nodeChild),
        };
    };
    const categoryIds = useMemo(() => (categoryHierarchyTree && defaultFilter ? parseCategoryIds(defaultFilter) : []), [categoryHierarchyTree, defaultFilter]);
    const mappedCategoryHierarchyTree = useMemo(() => (categoryHierarchyTree && defaultFilter ? walkAndMapCategoryHierarchyTree(categoryHierarchyTree) : null), [categoryHierarchyTree, defaultFilter]);
    return { categoryIds, categoryHierarchyTree: mappedCategoryHierarchyTree };
};
